import { T, useMessages } from 'gt-react';
import { Label } from 'src/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/components/ui/select';
import {
  OPERATOR_MODEL_TIERS,
  type RemoteDesktopExecuteModelTier,
} from './remote-desktop-config';

export type RemoteDesktopExecuteConfigFieldsProps = {
  model: RemoteDesktopExecuteModelTier;
  onModelChange: (model: RemoteDesktopExecuteModelTier) => void;
};

/**
 * Shared computer-use model selector for the remote-desktop execute step.
 * Used by the agent tools tab (`remote_desktop_execute` tool) and the
 * `remote_desktop_execute` workflow step renderer so both stay in sync.
 */
export function RemoteDesktopExecuteConfigFields({
  model,
  onModelChange,
}: RemoteDesktopExecuteConfigFieldsProps) {
  const m = useMessages();

  return (
    <div className="space-y-3">
      <div className="space-y-2">
        <Label>
          <T context="label for remote desktop operator computer-use model">
            Computer-Use Model
          </T>
        </Label>
        <Select
          value={model}
          onValueChange={(value) =>
            onModelChange(value as RemoteDesktopExecuteModelTier)
          }
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {OPERATOR_MODEL_TIERS.map((tier) => (
              <SelectItem key={tier.value} value={tier.value}>
                {m(tier.label)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">
          <T context="help text for operator computer-use model selector">
            Model used to drive the computer-use loop. Claude options use
            Anthropic computer use; GPT uses OpenAI computer use; Gemini uses
            Google computer use.
          </T>
        </p>
      </div>
    </div>
  );
}
